import RelationshipField from './RelationshipField.vue'
import './actions.css'

let sequence = 0
export function scopeModalIds(root, prefix) {
  const mapping = new Map()
  for (const element of [root, ...root.querySelectorAll('[id]')]) {
    if (element.dataset.relationshipOriginalId) mapping.set(element.dataset.relationshipOriginalId, element.id)
    if (!element.id || element.id.startsWith('vs') || element.id.startsWith(prefix)) continue
    const original = element.id; mapping.set(original, prefix + original); element.dataset.relationshipOriginalId = original; element.id = prefix + original
  }
  for (const element of root.querySelectorAll('[for],[form],[list],[href],[aria-controls],[aria-labelledby],[aria-describedby],[data-bs-target]')) for (const attr of ['for', 'form', 'list', 'href', 'aria-controls', 'aria-labelledby', 'aria-describedby', 'data-bs-target']) {
    const value = element.getAttribute(attr)
    if (!value || (attr === 'href' && !value.startsWith('#'))) continue
    const next = value.split(' ').map(id => id.startsWith('#') ? '#' + (mapping.get(id.slice(1)) || id.slice(1)) : mapping.get(id) || id).join(' ')
    if (next !== value) element.setAttribute(attr, next)
  }
}
export default {
  install(Vue) {
    const providers = new Map()
    Vue.prototype.$relationships = {
      register(entity, provider) { providers.set(entity, provider) },
      can(entity, action, source, context = {}) { return !!providers.get(entity)?.can(action, source, context) },
      async open(entity, action, source, context = {}) {
        const provider = providers.get(entity)
        if (!provider || !this.can(entity, action, source, context)) throw Error('Sem permissão para manter este relacionamento.')
        return provider.open({ action, source, context, present: config => this.present(source, config) })
      },
      async present(source, { component, props = {}, modalId, dialogSelector, prepare, save }) {
        const loaded = await component(), Component = loaded.default || loaded
        return new Promise((resolve, reject) => {
          const previous = document.activeElement, parentModal = previous?.closest('.modal.show') || source.$el?.closest?.('.modal.show'), prefix = `relationship-${++sequence}-`
          const workspace = document.createElement('div'); workspace.className = 'relationship-workspace'; workspace.style.setProperty('--relationship-z', String(1100 + sequence * 2)); document.body.appendChild(workspace)
          let record = null, observer, finished = false, modal
          const finish = error => {
            if (finished) return; finished = true
            observer?.disconnect(); document.removeEventListener('focusin', focusGuard, true); source.$off('hook:beforeDestroy', sourceDestroyed)
            if (modal && !dialogSelector) { window.$(modal).off('hidden.bs.modal'); window.$(modal).modal('dispose') }
            app.$destroy(); app.$el.remove(); workspace.remove()
            if (parentModal?.classList.contains('show')) document.body.classList.add('modal-open')
            window.requestAnimationFrame(() => previous?.focus?.()); error ? reject(error) : resolve(record)
          }
          const focusGuard = event => { if (workspace.contains(event.target)) event.stopImmediatePropagation() }
          const sourceDestroyed = () => finish()
          source.$once('hook:beforeDestroy', sourceDestroyed)
          document.addEventListener('focusin', focusGuard, true)
          const app = new Vue({ parent: source, render: h => h(Component, { ref: 'editor', props, on: { 'clear-errors': () => props.errors?.splice(0), 'validation-errors': errors => props.errors?.splice(0, props.errors.length, ...errors), 'relationship-saved': value => { record = value }, save: async payload => { try { const value = await save(payload, app.$refs.editor); if (value) { record = value; app.$refs.editor.close() } } catch (error) { app.$refs.editor.$emit('validation-errors', [error.message]) } } } }) })
          app.$mount(); workspace.appendChild(app.$el); app.$el.classList.add('relationship-source')
          const scope = () => { if (dialogSelector && modal && !modal.isConnected) return finish(); scopeModalIds(app.$el, prefix) }
          observer = new MutationObserver(scope); observer.observe(app.$el, { childList: true, subtree: true, attributes: true, attributeFilter: ['id', 'for', 'form', 'list', 'href', 'aria-controls', 'aria-labelledby', 'aria-describedby', 'data-bs-target'] })
          Vue.nextTick(async () => {
            try {
              if (dialogSelector) {
                await prepare(app.$refs.editor); await Vue.nextTick(); scope()
                modal = app.$el.matches(dialogSelector) ? app.$el : app.$el.querySelector(dialogSelector)
                if (!modal) throw Error('A rotina não disponibilizou seu diálogo de manutenção.')
                modal.classList.add('relationship-dialog')
                return
              }
              scope(); modal = modalId ? app.$el.querySelector(`[data-relationship-original-id="${modalId}"]`) : app.$el.matches('.modal') ? app.$el : app.$el.querySelector('.modal')
              if (!modal) throw Error('A rotina não disponibilizou um modal de manutenção.')
              window.$(modal).modal({ show: false, focus: false, backdrop: false }); window.$(modal).one('hidden.bs.modal', () => finish())
              await prepare(app.$refs.editor)
            } catch (error) { finish(error) }
          })
        })
      }
    }
    Vue.prototype.$relationshipModal = function (selector) {
      const id = selector.replace(/^#/, '')
      return window.$(this.$el).find(`[data-relationship-original-id="${id}"], [id="${id}"]`)
    }
    Vue.component('relationship-field', RelationshipField)
  }
}
